var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFraktklass250(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 250
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3",
    fill: "none",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33",
    d: "M3.818 22.14h.879c0-.005 1.182-2.592 2.777-2.592s2.731 2.592 2.731 2.592h10.462V7.559h-20V22.14Z",
    fill: "#ffaeae"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29",
    d: "M5.391 16.524a4.64 4.64 0 0 0 2.438-3.59 2.147 2.147 0 0 0-2.246-2.255 2.49 2.49 0 0 0-2.467 2.609l1.345.1c.03-.636.263-1.385 1.089-1.385.637 0 .91.435.91 1 0 1.578-2.184 3.024-3.307 3.7v1.116h4.959v-1.295Zm5.845-3.59a2 2 0 0 0-.961.222l.2-1.082h2.885v-1.3h-4l-.692 3.729 1.274.313a1.22 1.22 0 0 1 1.108-.607 1.057 1.057 0 0 1 1.167 1.132 1.165 1.165 0 0 1-1.183 1.274A1.183 1.183 0 0 1 9.8 15.533l-1.345.223a2.566 2.566 0 0 0 2.595 2.174 2.6 2.6 0 0 0 2.624-2.589 2.387 2.387 0 0 0-2.438-2.407m5.37 4.986c2.124 0 2.457-2.063 2.457-3.641 0-1.547-.334-3.63-2.5-3.63-2.255 0-2.467 2.194-2.467 3.62.002 1.457.235 3.651 2.51 3.651m-.02-1.317c-1.011 0-1.082-1.161-1.082-2.3 0-1.193.071-2.336 1.062-2.336s1.072 1.129 1.072 2.323c0 1.142-.071 2.313-1.052 2.313"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M7.414 25.606a3.322 3.322 0 1 1 3.322-3.322 3.326 3.326 0 0 1-3.322 3.322m0-5.316a1.993 1.993 0 1 0 1.993 1.993 2 2 0 0 0-1.993-1.993"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M24.69 25.606a3.322 3.322 0 1 1 3.322-3.322 3.326 3.326 0 0 1-3.322 3.322m0-5.316a1.993 1.993 0 1 0 1.993 1.993 2 2 0 0 0-1.993-1.993"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M20.7 22.948a.664.664 0 0 1-.664-.664V8.462a.4.4 0 0 0-.337-.133H1.666a.4.4 0 0 0-.338.138v13.019a.4.4 0 0 0 .337.133h2.981a.665.665 0 0 1 0 1.329h-2.98A1.576 1.576 0 0 1 0 21.486V8.462A1.576 1.576 0 0 1 1.666 7H19.7a1.576 1.576 0 0 1 1.666 1.462v13.821a.664.664 0 0 1-.666.665"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11",
    d: "M20.703 22.948H10.072a.665.665 0 1 1 0-1.329h10.631a.665.665 0 0 1 0 1.329"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12",
    d: "M30.539 22.948h-2.526a.665.665 0 0 1 0-1.329h2.526a.133.133 0 0 0 .132-.132v-3.686a.1.1 0 0 0-.012-.054l-2.378-5.352a.13.13 0 0 0-.121-.079h-7.457a.665.665 0 1 1 0-1.329h7.456a1.46 1.46 0 0 1 1.336.868l2.379 5.352a1.45 1.45 0 0 1 .126.594v3.686a1.464 1.464 0 0 1-1.461 1.461"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13",
    d: "M22.032 22.948h-1.329a.665.665 0 0 1 0-1.329h1.329a.665.665 0 1 1 0 1.329"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFraktklass250);
export default __webpack_public_path__ + "static/media/fraktklass-250.f02bc3ff597fc9e23f6c38cda44f1664.svg";
export { ForwardRef as ReactComponent };